import PortalIdParser from 'PortalIdParser';

export const getAppSettingsUrl = ({
  appId,
  portalId,
  path = '',
}: {
  appId: number | string;
  portalId?: number;
  path?: string;
}): string => {
  const normalizedPath = path.replace(/^\//, '');

  return `/integration/${portalId ?? PortalIdParser.get()}/settings/${appId}${
    normalizedPath ? `/${normalizedPath}` : ''
  }`;
};
